import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import Input from "../BaseControls/Input";
import { controlPropTypes } from "../formhelpers";

export default function Text(props) {
    return (
        <ControlTemplate {...props} className="string-field">
            <Input
                {...props}
                valueType="string"
            />
        </ControlTemplate>
    );
}

Text.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/StringField/text.js